<div class="authentication">
  <router-outlet></router-outlet>
</div>
